
import { Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import PageLayout from '@/components/layout/PageLayout';
import { useAuth } from '@/contexts/AuthContext';

export default function AccountSuspended() {
  const { user, profile, isLoading, signOut } = useAuth();

  // If still loading, show loading state
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  // If user is not logged in, redirect to login page
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // If user is not suspended, redirect to home page
  if (!profile?.suspended) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageLayout>
      <div className="container max-w-md mx-auto py-16">
        <div className="bg-red-50 p-8 rounded-lg border border-red-200 text-center space-y-6">
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-red-800">Account Suspended</h1>
            <p className="text-red-700">
              Your account has been suspended by an administrator.
              Please contact us if you believe this was done in error.
            </p>
          </div>
          
          <div className="space-y-4">
            <p className="text-sm text-red-600">
              If you need additional information about your account status, please reach out to us directly.
            </p>
            
            <Button variant="outline" onClick={() => signOut()}>
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
